<ngb-toast *ngFor="let toast of toastService.toasts" [autohide]="true"
  [delay]="toast.delay || 5000" (hide)="toastService.remove(toast)" [class]="toast.classname || ''">{{toast.body}}</ngb-toast>
